import React, { useState } from 'react';
import { useTemplateTagActions } from './useTemplateTagActions';
import { useFilteredTemplateTags } from './useFilteredTemplateTags';

/**
 * Хук для управления тегами.
 * Комбинирует загрузку, фильтрацию, создание и привязку тегов.
 */
export const useTemplateTags = (
	templateId: string,
	type: 'TEAM_TEMPLATE' | 'PRIVATE_TEMPLATE',
	search: string,
) => {
	const { filteredTags } = useFilteredTemplateTags(search);
	const { bindCreatedTag } = useTemplateTagActions(templateId, type);

	const [tagName, setTagName] = useState('');

	const onTagNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setTagName(event.target.value);
	};

	const handleCreateTag = async () => {
		if (tagName.length >= 2) {
			await bindCreatedTag(tagName);
			setTagName('');
		}
	};

	return {
		tagName,
		filteredTags,
		bindCreatedTag,
		onTagNameChange,
		handleCreateTag,
	};
};
